import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="cctv--popup"

export default class extends Controller {
  static targets = ["popup"]
  static values = {
    url: String
  }

  connect() {

  }

  open() {
    window.open(this.urlValue, "_blank", "toolbar=no,scrollbars=yes,resizable=no,width=750,height=610");
  }

}